
import * as tagsRetrievers from 'data/tags/retrievers';
import { isSplitTxn } from 'data/transactions/utils';
import { noNaN } from 'utils/utils';

// -------------------------------------------------------
// updateNewTags
//
// takes an immutable transaction, and checks for tags with ID="0" and tries to
// find a tag that is suitable with a real ID.  Returns an immutable transaction
// with updates if they were needed
//
export function updateNewTags(txn, dropPlaceholders = false, state) {

  let retTxn = txn;
  if (txn.tags) {
    const newTags = txn.tags.map((tag) => {
      if (noNaN(tag.id) === 0) {
        const ret = tagsRetrievers.getTagByName(tag.name, state);
        return ret && ret.id ? { id: ret.id } : tag;
      }
      return tag;
    });
    retTxn = txn.set('tags', newTags.filter((x) => x !== null && (!dropPlaceholders || noNaN(x.id) !== 0)));
  }
  if (isSplitTxn(retTxn)) {
    const newItems = retTxn.split.items.map((item) => {
      if (item.tags) {
        const newSplitTags = item.tags.map((tag) => {
          if (noNaN(tag.id) === 0) {
            const ret = tagsRetrievers.getTagByName(tag.name, state);
            if (ret && ret.id) {
              return { id: ret.id }
            }
            return dropPlaceholders ? null : tag;
          }
          return tag;
        });
        return item.set('tags', newSplitTags.filter((x) => x !== null && (!dropPlaceholders || noNaN(x.id) !== 0 )));
      }
      return item;
    });

    retTxn = retTxn.setIn(['split','items'], newItems);
  }
  return retTxn;
}


